import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import { SkinWPhotoProps } from '../SkinWPhoto';
import { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/DoubleBorderPhoto.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const DoubleBorderPhotoSkin: React.FC<Omit<
  BaseWPhotoSkinProps,
  'skinsStyle'
>> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const DoubleBorderPhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={DoubleBorderPhotoSkin} />
);

export default DoubleBorderPhoto;
